<button [disabled]="!dane" nbButton size="small" (click)="export()"><nb-icon icon="cloud-download-outline"></nb-icon>XLS</button>
